import React, {Component} from 'react';
import './IHealthcare.css';
import IndustryIndividualCard from '../Components/IndustryIndividualCard/IndustryIndividualCard.js'
import medicalCover from '../../../images/individual/medical/MedicalCover.jpg';
import medicalImg1 from '../../../images/individual/medical/Medical1.jpg'
import medicalImg2 from '../../../images/individual/medical/PPE.jpg';

export default class IHealthcare extends Component {
	render() {
		return (
			<div className="i_healthcare_container">
				<div className="i_healthcare_container_cover_image">
					<div className="i_healthcare_container_cover_text">HEALTHCARE</div>
					<img src={medicalCover} />
				</div>
				<div className="i_healthcare_subtitle">
					<span>In 2019, PPI under its subsidiary Aries Holding in the UK  has has partner with the leading healthcare providers and operators to build and own exceptional care habitats to meet the increasing demand in 2nd tier cities such as Manchester and Liverpool.</span>
				</div>
				<div className="i_healthcare_content">
				<IndustryIndividualCard
					link='/healthcare/provider'
					clickable={true}
					moreEnabled = 'true'
					image={medicalImg1}
					title='HEALTHCARE PROVIDER'
					description1='In 2019, PPI has invested into Aries Healthcare in the United Kingdom to offer as the leading healthcare provider and operators to build and own exceptional care habitats to meet the increasing demand in the 2nd Tier City such as Manchester and Liverpool.'
					description2='Liverpool will break ground on a two-storey heritage building which undergone a major and its slated for its open in the year 2021. The facility will offer its first of its kind for the niche to the mass market to meet the demand for the EMI Plus (Elderly & Mentally Infirm patients, PLUS younger patients). The facility provides accommodation and specialist support for those with severe and enduring mental health problems to enable people to develop the skills and independence. Our operation is supported by the National Health Services (NHS) schemes under the UK government. '

				/>
				<IndustryIndividualCard
					link='#'
					clickable={false}
					image={medicalImg2}
					title='PERSONAL PROTECTION EQUIPMENT'
					description1='Since the beginning of the Covid-19 pandemic, the healthcare industry has evolves and with the growing demand of the personal protective equipment. To address to the challenges of the shortages, PPI has partnered with several manufacturing companies worldwide has set-up a new business unit to help identify and made available the most appropriate solutions to facilitate with the needs of medical products and equipment for use by patients, medical frontliner and healthcare systems. '
					description2='We have work alongside government procuring agencies around the world to facilities on the acquisition of the goods such as Respirator and Surgical Mask, Gloves, ICU ventilators etc. Our products are certified by various governing bodies such as FDA, TUV, CE, ISO etc and are ready to be delivered.'
				/>
				</div>
			</div>
		);
	}
}
